import {MapNode} from 'common/src/modules/nodes/nodes.types';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';
import {DateTime} from 'luxon';
import {addOrUpdateCardInputSchema} from '../../../../schemas/baseSchemas';
import {cardToText} from '../../cardDetailsV2/textualConverters';

const ID_DISTINCTION_NOTE = `\n IMPORTANT: Strictly distinguish ID types (e.g. Card ID vs Creative ID vs Feed ID).`;

export type GetOrCreateCard = (cardId: number, store: CLStore) => Promise<MapNode>;

export default async function preProcessStandaloneAgent<TScratchpad>(
  params: ToolExecuteParams<typeof addOrUpdateCardInputSchema, TScratchpad>,
  store: CLStore,
  getOrCreateCard: GetOrCreateCard,
): Promise<{promptToUse: string; normalizedCardId: number; card: MapNode}> {
  const {prompt} = params.input;

  const normalizedCardId = (params.input.cardId ?? 0) || 0;
  const card = await getOrCreateCard(normalizedCardId, store);

  const promptWithDateInstructions = prompt.concat(
    `\n When using dates, use the ISO format for the dates. 
      Today's date is ${DateTime.now().toISO()}.`,
  );

  const cardText = cardToText(card, 'full');
  const promptToUse = `${promptWithDateInstructions}\n\nCard state:\n${cardText}${ID_DISTINCTION_NOTE}`;

  return {
    promptToUse,
    normalizedCardId,
    card,
  };
}
